import { useSessionStore } from '@/entities/session';
import { globalSocket } from '@/shared/api/sockets';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useEmrIntegrationStore } from '../model/store';

export const useInitEmrSockets = () => {
  const refetchUser = useSessionStore((state) => state.refetchUser);
  const updateIntegrationProgress = useEmrIntegrationStore(
    (state) => state.updateIntegrationProgress
  );
  const setIsEmrInProgress = useEmrIntegrationStore(
    (state) => state.setIsInProgress
  );

  useEffect(() => {
    globalSocket.on('sync-progress-updated', ({ title, progress }) => {
      if (progress === 100) {
        toast.success('EMR Integrated successfully!');
        updateIntegrationProgress({ title, progress: 100 });
        setIsEmrInProgress(false);
        refetchUser();
        return;
      }
      updateIntegrationProgress({ title, progress });
    });

    globalSocket.on('sync-failed', ({ title }) => {
      toast.error(title || 'EMR Integration failed. Please try again later.');
      setIsEmrInProgress(false);
      updateIntegrationProgress(undefined);
    });
  }, []);
};
